import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const SuccessMessage = styled.div`
  display: flex;
  padding: 48px 16px 48px 22px;
  align-items: center;
  justify-content: center;
  @media ${device.mobileMin} {
    font-size: ${variables.fontSize18};
  }
`

export const SuccessContent = styled.div`
  text-align: center;
  @media (min-width: 640px) {
    width: 400px;
  }
`

export const SuccessText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 34px;
  @media ${device.mobileMin} {
    flex-direction: row;
    margin-bottom: 63px;
  }
`

export const SuccessCircle = styled.div`
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  @media ${device.mobileMin} {
    margin-bottom: 0px;
    margin-right: 16px;
  }
`

export const SuccessTitle = styled.div`
  font-size: 18px;
  color: ${colors.mainText};
  line-height: 27px;
  padding-left: 16px;
  padding-right: 16px;
  @media ${device.mobileMin} {
    font-size: 20px;
    padding-left: 0px;
    padding-right: 0px;
    line-height: 30px;
  }
`
